import React from 'react'
import { connect } from 'react-redux'
import CategoryActions from '../../Redux/CategoryRedux'
import FileUploader from '../FileUploader'
import FilesActions from '../../Redux/FilesRedux'
import { currentBranch } from '../../Utils/PrivilegeUtils'

class CreateCategory extends React.Component {
  constructor (props) {
    super(props)
    this.branch = currentBranch()
    this.state = {
      form: {
        name: '',
        icon_file: null,
        image_file: null
      },
      image_type: '',
      file: null,
      uploaded: false
    }
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data) {
      let form = { ...this.state.form }
      form.image_file = newProps.files.data.upload[0].filename
      form.icon_file = newProps.files.data.upload[0].filename
    }
  }

  _upload = (event) => {
    event.preventDefault()
    let data = new FormData()
    data.append('files', this.state.file.files[0])
    data.append('type', 'category')
    data.append('image_type', this.state.image_type)
    this.props.upload(data)
    this.setState({ uploaded: true })
  }

  _fileUploaded = (filename, field) => {
    let form = { ...this.state.form }
    form[field] = filename
    this.setState({ form })
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = { ...this.state.form }
    data.iso_code = this.branch
    this.props.createCategory(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Create Category</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Category</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                placeholder='Category Name'
                className='form-control'
                value={this.state.form.name}
                onChange={(event) => this._inputChange(event, 'name')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label htmlFor='image' className='control-label'>Image File(<span className='text-orange'>518x344</span>)</label>
            </div>
            <div className='col-9'>
              <FileUploader required setting={{ type: 'category', image_type: 'image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image_file')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label htmlFor='image' className='control-label'>Icon File(<span className='text-orange'>100x100</span>)</label>
            </div>
            <div className='col-9'>
              <FileUploader required setting={{ type: 'category', image_type: 'icon' }} onUploaded={(filename) => this._fileUploaded(filename, 'icon_file')} />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
  createCategory: (data) => dispatch(CategoryActions.createCategoryRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CreateCategory)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/CreateCategory.js